import {
  AddTimesheetResponse,
  TimesheetError,
  Timesheet,
  TimesheetResponse,
  DeletedTimesheet,
  TimesheetPayload,
  ApproveTimesheetPayload,
  TimesheetCommonResponse,
  AddNotePayload,
  AddNoteResponse,
  NotesPaylod,
  NotesResponse,
  TimesheetReportPayload,
  TimesheetChangeCMPayload,
  ChangeRatePayload,
  ExcelTimesheetReportPayload,
  TimesheetReportExcelResponse,
} from '@core/interface/timesheet';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const TimesheetActions = createActionGroup({
  source: 'Timesheet',
  events: {
    'Load Timesheets': props<TimesheetPayload>(),
    'Load Timesheets Success': props<TimesheetResponse>(),
    'Load Timesheets Failure': props<TimesheetError>(),
    'Add Edit Timesheet': props<{ timesheet: Timesheet }>(),
    'Add Timesheet Success': props<AddTimesheetResponse>(),
    'Update Timesheet Success': props<AddTimesheetResponse>(),
    'Add Timesheet Failure': props<TimesheetError>(),
    'Update Timesheet Failure': props<TimesheetError>(),
    'Delete Timesheet': props<{ id: number }>(),
    'Delete Timesheet Success': props<DeletedTimesheet>(),
    'Delete Timesheet Failure': props<TimesheetError>(),
    'Approve Timesheets': props<ApproveTimesheetPayload>(),
    'Approve Timesheets Success': props<TimesheetCommonResponse>(),
    'Approve Timesheets Failure': props<TimesheetError>(),
    'Add Audit Note ': props<AddNotePayload>(),
    'Add Audit Success': props<AddNoteResponse>(),
    'Add Audit Failure': props<TimesheetError>(),
    'Load Audit Notes ': props<NotesPaylod>(),
    'Load Audit Notes Success': props<NotesResponse>(),
    'Load Audit Notes Failure': props<TimesheetError>(),
    'Reset Timesheet Params Status': emptyProps(),
    'Reset Timesheets': emptyProps(),
    'Reopen Timesheets': props<TimesheetPayload>(),
    'Reopen Timesheets Success': props<TimesheetCommonResponse>(),
    'Reopen Timesheets Failure': props<TimesheetError>(),
    'Load Timesheet Report': props<TimesheetReportPayload>(),
    'Load Timesheet Report Success': props<TimesheetResponse>(),
    'Load Timesheet Report Failure': props<TimesheetError>(),
    'Reset Timesheet Report': emptyProps(),
    'Export Timesheet Report Excel': props<ExcelTimesheetReportPayload>(),
    'Export Timesheet Report Excel Success':
      props<TimesheetReportExcelResponse>(),
    'Export Timesheet Report Excel Failure': props<TimesheetError>(),
    'Reset Delete status': emptyProps(),
    'Un Submit Timesheet': props<NotesPaylod>(),
    'Un Submit Timesheet Success': props<TimesheetCommonResponse>(),
    'Un Submit Timesheet Failure': props<TimesheetError>(),
    'Change CM': props<TimesheetChangeCMPayload>(),
    'Change CM Success': props<TimesheetCommonResponse>(),
    'Change CM Failure': props<TimesheetError>(),
    'Store Manual Overtime': props<ChangeRatePayload>(),
    'Store Manual Overtime Success': props<TimesheetCommonResponse>(),
    'Store Manual Overtime Failure': props<TimesheetError>(),
    'Admin Direct Approve': props<{ ids: string }>(),
    'Admin Direct Approve Success': props<TimesheetCommonResponse>(),
    'Admin Direct Approve Failure': props<TimesheetError>(),
  },
});
